<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import ContextProvider from './components/ContextProvider/ContextProvider.vue'
import KonamiCode from './components/EasterEgg/KonamiCode.vue'

const route = useRoute()
</script>

<template>
    <KonamiCode v-slot="props">
        <div class="app-content" v-bind="props">
            <ContextProvider>
                <template #default="props">
                    <v-responsive>
                        <v-app :theme="props.theme">
                            <RouterView :route="route" />
                        </v-app>
                    </v-responsive>
                </template>
            </ContextProvider>
        </div>
    </KonamiCode>
</template>
